import React from 'react';

const optional = (condition, children) => <div>{condition ? children : ''}</div>;

export default optional;
